import type { ComponentPropsWithRef } from 'react';

import { useTranslation } from 'react-i18next';

import { clsx } from '~/styles/utils';

import { Button } from '../Button/Button';
import { chipStyle, removeButtonStyle } from './FilterChips.css';

type Props = Omit<ComponentPropsWithRef<'li'>, 'children'> & {
  children: string;
  onRemove: () => void;
};

export const FilterChip = ({ children, onRemove, ...delegated }: Props) => {
  const { t } = useTranslation(['common']);

  return (
    <li {...delegated} className={clsx(chipStyle, delegated.className)}>
      {children}

      <Button
        aria-label={t('common:datatable.deleteFilter', { filter: children })}
        className={removeButtonStyle}
        icon="CloseSmall"
        onClick={onRemove}
      />
    </li>
  );
};
